// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"263":"464c6a4b","320":"148cbc9f","373":"df49f425","500":"d3a5d56d","922":"4b15627f"}[chunkId] + ".chunk.js";
};